const YMQ_CART_BUNDLE_CONFIG = {
  styleId: 'ymq-cart-bundle-note-style',
  startedAttr: 'data-ymq-cart-bundle-note-init',
  bundleProductIds: ['7876016242774'],
  bundleTitleMatch: 'Bundled with Swing Bed',
  classes: {
    enhanced: 'ymq-cart-bundle-item--enhanced',
    note: 'ymq-cart-bundle-note',
    tag: 'ymq-cart-bundle-tag',
    message: 'ymq-cart-bundle-message'
  },
  selectors: {
    cartRoot: '.ymq-cart-app',
    itemsContainer: '.ymq-cart-app-items-info',
    cartItem: '.ymq-cart-app-item',
    titleProperties: '.ymq-cart-app-item-title-properties'
  },
  message: 'Your selected cushion fabric and sizing specifications have been added and are included with your Swing Bed purchase.',
  tag: 'Bundle add-on'
};

class YmqCartBundleNote {
  constructor() {
    this.observer = null;
  }

  static init() {
    if (document.body.getAttribute(YMQ_CART_BUNDLE_CONFIG.startedAttr) === 'true') {
      return;
    }

    document.body.setAttribute(YMQ_CART_BUNDLE_CONFIG.startedAttr, 'true');
    YmqCartBundleNote.ensureStyles();

    const instance = new YmqCartBundleNote();
    instance.enhance();
    instance.observe();
  }

  static ensureStyles() {
    if (document.getElementById(YMQ_CART_BUNDLE_CONFIG.styleId)) {
      return;
    }

    const style = document.createElement('style');
    style.id = YMQ_CART_BUNDLE_CONFIG.styleId;
    style.textContent = [
      '.' + YMQ_CART_BUNDLE_CONFIG.classes.enhanced + ' {',
      '  background: rgba(35, 87, 81, 0.06);',
      '  border-left: 3px solid #235751;',
      '  border-radius: 6px;',
      '  padding-left: 8px;',
      '  margin-bottom: 8px;',
      '}',
      '.' + YMQ_CART_BUNDLE_CONFIG.classes.note + ' {',
      '  display: flex;',
      '  flex-wrap: wrap;',
      '  align-items: center;',
      '  gap: 6px;',
      '  margin: 8px 0 0;',
      '}',
      '.' + YMQ_CART_BUNDLE_CONFIG.classes.tag + ' {',
      '  display: inline-block;',
      '  font-size: 11px;',
      '  font-weight: 700;',
      '  line-height: 1.2;',
      '  letter-spacing: 0.04em;',
      '  text-transform: uppercase;',
      '  color: #fff;',
      '  background: #235751;',
      '  border-radius: 4px;',
      '  padding: 4px 8px;',
      '}',
      '.' + YMQ_CART_BUNDLE_CONFIG.classes.message + ' {',
      '  display: inline-block;',
      '  font-size: 12px;',
      '  line-height: 1.3;',
      '  color: #333;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  isBundleItem(item) {
    if (!item) return false;

    if (item.classList.contains('ymq-option-cart-item-bundle')) return true;
    if (item.hasAttribute('ymq-cart-app-bundle-variant-chidren')) return true;

    const productId = item.getAttribute('ymq-cart-app-item-product-id');
    if (productId && YMQ_CART_BUNDLE_CONFIG.bundleProductIds.includes(productId)) {
      return true;
    }

    const titleLink = item.querySelector('.ymq-cart-app-item-title a');
    const titleText = titleLink ? titleLink.textContent.trim() : '';
    return titleText.indexOf(YMQ_CART_BUNDLE_CONFIG.bundleTitleMatch) !== -1;
  }

  buildNote() {
    const note = document.createElement('p');
    note.className = YMQ_CART_BUNDLE_CONFIG.classes.note;

    const tag = document.createElement('span');
    tag.className = YMQ_CART_BUNDLE_CONFIG.classes.tag;
    tag.textContent = YMQ_CART_BUNDLE_CONFIG.tag;

    const message = document.createElement('span');
    message.className = YMQ_CART_BUNDLE_CONFIG.classes.message;
    message.textContent = YMQ_CART_BUNDLE_CONFIG.message;

    note.appendChild(tag);
    note.appendChild(message);
    return note;
  }

  enhanceItem(item) {
    if (!this.isBundleItem(item)) return;

    item.classList.add(YMQ_CART_BUNDLE_CONFIG.classes.enhanced);

    const titleProperties =
      item.querySelector(YMQ_CART_BUNDLE_CONFIG.selectors.titleProperties) ||
      item.querySelector('.ymq-cart-app-item-title')?.parentElement;

    if (!titleProperties || titleProperties.querySelector('.' + YMQ_CART_BUNDLE_CONFIG.classes.note)) {
      return;
    }

    titleProperties.appendChild(this.buildNote());
  }

  enhance() {
    document
      .querySelectorAll(YMQ_CART_BUNDLE_CONFIG.selectors.cartItem)
      .forEach((item) => this.enhanceItem(item));
  }

  observe() {
    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new MutationObserver(() => {
      this.enhance();
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', YmqCartBundleNote.init);
} else {
  YmqCartBundleNote.init();
}
